import React, { useEffect, useState } from "react";
import request from "superagent";
import PropTypes from "prop-types";

import AddIcon from "@material-ui/icons/Add";
import GetAppIcon from "@material-ui/icons/GetApp";
import { Button } from "@material-ui/core";

import Analytics from "../../../../helpers/analytics";

function AddToListDownload(props) {
  const { addFavorite, auth, location, video, history } = props;
  let insider = auth.loggedIn && auth.user.roles.includes("ROLE_INSIDER");

  const pathname = location && location.pathname ? location.pathname : "/licensing";

  const [loading, setLoading] = useState(false);
  const [isMaster, setIsMaster] = useState(false);

  const onClickDownload = (isMaster = false) => {
    setIsMaster(() => isMaster);
    let url = `/api/public/video/downloadVideo/${video.jmId}`;

    if (isMaster) {
      url = `/api/video/downloadVideo/${video.jmId}`;
    }
    if (!auth.loggedIn) {
      localStorage.setItem("prevPath", pathname);
      localStorage.setItem("onBoardingDownload", video.jmId);
      localStorage.setItem("downloadVideo", true);
      Analytics.track("Download Preview", {
        category: "LP-VideoDetail",
        label: `Not Logged In - JV# ${video.jmId}`
      });

      history.push("/licensing/login");
    } else {
      setLoading(true);
      if (!insider && video.isPublicDownloadAvailable) {
        Analytics.track("DownloadWatermarked", {
          category: "LP-VideoDetail",
          label: `Non Insider - JV# ${video.jmId} - ${auth.userProfile.profile.id}`
        });
      } else {
        Analytics.track(isMaster ? "DownloadMaster" : "DownloadPreview", {
          category: "LP-VideoDetail",
          label: `Insider - JV# ${video.jmId} - ${auth.userProfile.profile.id}`
        });
      }

      request
        .post(url)
        .set("Content-Type", "application/json")
        .set("Authorization", `Bearer ${auth.user.access_token}`)
        .send({})
        .then((res, err) => {
          if (!res.ok) {
            console.log(err);
          } else {
            window.location = res.body.url;
            setLoading(false);
          }
        });
    }
  };

  const onClickAddToFavorite = () => {
    if (auth.loggedIn) {
      Analytics.track("SavedVideo", {
        category: "LP-VideoDetail",
        label: video.jmId
      });
      addFavorite(video.jmId, auth.user.access_token);
    } else {
      localStorage.setItem("prevPath", pathname);
      localStorage.setItem("onBoardingAddToList", video.jmId);
      Analytics.track("SavedVideo", {
        category: "LP-VideoDetail",
        label: `Not Logged In - JV# ${video.jmId}`
      });
      history.push("/licensing/login");
    }
  };

  useEffect(() => {
    if (localStorage.getItem("downloadVideo") && props.history.action === "PUSH" && auth.loggedIn) {
      localStorage.removeItem("downloadVideo");
      onClickDownload(false);
    }
  }, []);

  return (
    <div className="action-buttons">
      <Button
        variant="outlined"
        className="addTo__list"
        onClick={onClickAddToFavorite}
        startIcon={<AddIcon />}
      >
        Save
      </Button>
      {video.isPublicDownloadAvailable && (
        <Button
          variant="outlined"
          onClick={() => onClickDownload()}
          data-toggle="tooltip"
          data-placement="top"
          title="Download Footage"
          disabled={loading && !isMaster}
          startIcon={<GetAppIcon />}
        >
          Preview
        </Button>
      )}
      {insider && (
        <Button
          variant="outlined"
          onClick={() => onClickDownload(true)}
          data-toggle="tooltip"
          data-placement="top"
          title="Download Footage"
          disabled={loading && isMaster}
          startIcon={<GetAppIcon />}
        >
          Master
        </Button>
      )}
    </div>
  );
}

AddToListDownload.propTypes = {
  auth: PropTypes.shape().isRequired,
  video: PropTypes.shape().isRequired,
  addFavorite: PropTypes.func.isRequired
};

export default AddToListDownload;
